import { PlayerConfig } from '../pages/Quiz/QuizGame';

export const PARIDHI_CONFIG: PlayerConfig = {
  playerName: 'Paridhi',
  localStorageKey: 'paridhi-quiz-state',
  pageTitle: "Paridhi's Quiz 🌈",

  questionTypes: [
    'letter-recognition',
    'counting',
    'colors',
    'shapes',
    'animals',
    'opposites',
    'rhyming',
    'beginning-sound',
    'simple-math',
    'patterns',
  ],

  difficultyConfig: {
    0: {
      label: 'Normal 😊',
      desc: 'Genuinely easy and confidence-building. The correct answer should feel obvious to most 5-year-olds.',
    },
    1: {
      label: 'Harder 🤔',
      desc: 'A small but noticeable step up. Counting up to 10. Math up to 10. Less common animals or sounds.',
    },
    2: {
      label: 'Challenge 🔥',
      desc: 'Stretching but still age-appropriate. Counting up to 15. Math up to 20. Trickier beginning sounds.',
    },
  },

  typeInstructions: {
    'letter-recognition': `Ask the child to identify an uppercase or lowercase letter, or match a letter to a word it starts with.`,
    counting: `Show a number of emoji objects in the question text and ask how many there are.`,
    colors: `Ask the child to identify the color of a familiar object. Use only the 8 basic colors.`,
    shapes: `Ask the child to identify a shape by name. Use only: circle, square, triangle, rectangle, star, heart, oval.`,
    animals: `Ask about animal sounds, animal homes, what animals eat, or baby animal names.`,
    opposites: `Give one word and ask for its opposite. Use only concrete, everyday opposites a 5-year-old knows.`,
    rhyming: `Give one word and ask which of four answer choices rhymes with it.`,
    'beginning-sound': `Ask what letter sound a word or pictured object starts with.`,
    'simple-math': `Single-digit addition or subtraction only.`,
    patterns: `Show a simple repeating emoji pattern with the last item missing and ask what comes next.`,
  },

  personaPrompt: `You are a warm, encouraging, and playful quiz teacher for Paridhi, a 5-year-old who is starting Kindergarten. She is bright, enthusiastic, and loves animals, drawing, and colorful things. Always use emojis generously.`,

  specialRules: `
STRICT RULES FOR THIS AGE GROUP:
- Questions must be answerable by a child who cannot yet read fluently. Rely on emojis and numbers, not long sentences.
- Answer choices must be short: single words, single numbers, or single emojis. Never a full sentence as an answer.
- Never ask multi-step questions. One idea per question only.
- Never use academic instruction language.
- Never ask about time (clocks, calendars) or money.
- Never use negative phrasing ("Which one is NOT a...") — always ask positively.
- Praise must be warm and specific.
- The hint/explanation after a wrong answer must be one simple sentence a 5-year-old understands.
`,
};
